import React, { Component } from 'react';

class ButtonSubmit extends Component {

    /**
     * Render the component.
     *
     * @returns {*} - A generic submit button component.
     */
    render() {

        return(
            <React.Fragment>

                <button type="submit" className={`btn btn-primary btn-lg ${this.props.customClasses ? this.props.customClasses : 'ml-2'}`}>
                    Submit
                </button>

            </React.Fragment>
        )
    };
}

export default ButtonSubmit;